import { useQuery } from "@tanstack/react-query";
import { Modal, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { MdDeleteForever } from "react-icons/md";
import AntTable from "../../../components/AntTable/AntTable";
import BlogForm from "../../../components/admin/AdminBlog/BlogForm";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import DeleteModal from "../../../components/common/DeleteModal";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import { DeleteBlogAdmin, ListBlogsAdmin } from "../../../network/admin";

type Props = {};

const AdminBlog = (props: Props) => {
  const [modal, setModal] = useState(false);
  const [searchHeader, setSearchHeader] = useState();
  const [isFilter, setIsFilter] = useState({});

  const [page, setPage] = useState<number>(1);
  const [id, setId] = useState<number>(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const closeModal = () => {
    setModal(false);
    setId(0);
  };

  const { data, isLoading } = useQuery(
    ["blogs", page, searchHeader, isFilter],
    () =>
      ListBlogsAdmin({
        page,
        search: searchHeader,
        ...isFilter,
      })
  );
  const openModal = (id: any) => {
    setModal(true);
    setId(id);
  };
  const [openDeleteModal, setOpenDeleteModal] = useState<any>(false);

  const breadcrumb = useBreadcrumb([], 1);
  const columns: ColumnsType<any> = [
    {
      title: <div className={`text-[#9999A7] text-sm font-normal`}>Title</div>,
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div>
          <div
            className={`text-color-primary text-sm font-medium truncate w-52 mx-auto`}
          >
            {record?.title}
          </div>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Category</div>,
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => {
        console.log(record);

        return (
          <div className="text-sm font-medium text-color-primary" dir="ltr">
            {record?.categories.map((e: any) => (
              <Tag className="text-color-primary">{e.name}</Tag>
            ))}
          </div>
        );
      },
    },

    {
      title: <div className="text-[#9999A7] text-sm font-normal">Date</div>,
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {dayjs(record?.date).format("YYYY-MM-DD")}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Author</div>,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={`text-sm font-medium flex items-center w-full justify-between`}
        >
          <span className="w-full text-color-primary">
            {record?.user?.email}
          </span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Status</div>,
      dataIndex: "Status",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={`text-sm font-medium flex items-center w-full justify-between`}
        >
          <Tag
            style={{ color: record?.is_active ? "#479821" : "#9999A7" }}
            className="w-full font-semibold text-center bg-white border-none"
          >
            {record?.is_active ? "Active" : "Inactive"}
          </Tag>
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="flex items-end !justify-end w-full gap-4">
          <div
            onClick={() => openModal(record.id)}
            className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          >
            <AiOutlineEdit className="text-color-primary" />
          </div>{" "}
          <div
            onClick={() => {
              setOpenDeleteModal(true);
              setId(record?.id);
            }}
            className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          >
            <MdDeleteForever className="text-[#C43535]" />
          </div>
        </div>
      ),
    },
  ];
  console.log(data?.data);

  return (
    <>
      <DeleteModal
        visible={openDeleteModal}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        onDelete={DeleteBlogAdmin} // Pass the delete function for "Package"
        data={id}
        confirmationHeader={"Are you sure you want to delete this Blog?"}
        confirmationText={""}
        queryKey={"blogs"} // Pass the correct key here
        successMessage={"Blog deleted successfully"}
        afterDelete={() => {
          setOpenDeleteModal(false);
        }}
      />
      {breadcrumb}
      <Modal
        width={1000}
        open={modal}
        centered
        onCancel={closeModal}
        className="!w-[90%]"
        footer={null}
        destroyOnClose
      >
        <BlogForm id={id} close={closeModal} />
      </Modal>
      <AntTable
        tableColumns={columns}
        tableHeader={
          <div className="flex items-center justify-end">
            <HeaderTableSuperAdmin
              searchHeader={searchHeader}
              setSearchHeader={setSearchHeader}
              selectedRowKeys={selectedRowKeys}
              labelButton="New Blog"
              filterType={{ dateAdded: true, tags: true }}
              setIsFilter={setIsFilter}
              hasModal={true}
              modalId={3}
              placeholderSearch={"Search Blogs"}
              confirmMessage={undefined}
              setConfirmMessage={undefined}
              closeModalConfirm={undefined}
              isModalConfirmOpen={undefined}
              showModalConfirm={undefined}
            />
          </div>
        }
        tableData={data?.data || []}
        isLoading={isLoading || false}
        expandRowByClick={false}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </>
  );
};

export default AdminBlog;
